const refreshTokenResource = 'v1/auth/refresh-token';

const letClinicBaseUrl = `${process.env.NEXT_PUBLIC_BASE_URL}api/`;

export { letClinicBaseUrl, refreshTokenResource };
